import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { CombinedEvaluation } = await import('./index');
    return {
        Component: CombinedEvaluation,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
